function getRandomInt(max) {
	return Math.floor(Math.random() * max);
}
const GetStatus = (item, start, end) => {
	const now = new Date();
	if (item.status === "MINTING") return "Minting";
	if (item.status === "MINTED") return "Minted";
	if (item.status === "HOLD_INVOICE") return "HOLD_INVOICE";
	if (now < start) {
		return "Upcoming";
	}
	if (item.type === "SINGLE_EDITION") {
		if (item.bids.length < item.totalNFTs) return "Ongoing";
		else return "Closed";
	}

	if (start < now && now < end) {
		if (item.type === "AUCTION_EDITION") return "Ongoing";
		else if (item.bids.length < item.totalNFTs) return "Ongoing";
		else return "Closed";
	}
	if (end < now) {
		if (item.bids.length === 0) return "Delete";
		return "Closed";
	}
};
export { getRandomInt, GetStatus };
